import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-597">
      <li className="flex" data-id="element-598">
        <span className="mr-2" data-id="element-599">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-600">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-601">
        <span className="mr-2" data-id="element-602">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-603">
          Photography
        </Link>
      </li>
      <li className="flex" data-id="element-604">
        <span className="mr-2" data-id="element-605">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-606">
          Editorial
        </Link>
      </li>
      <li className="flex" data-id="element-607">
        <span className="mr-2" data-id="element-608">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-609">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-610">
        <span className="mr-2" data-id="element-611">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-612">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-613">
        <span className="mr-2" data-id="element-614">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-615">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;